"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIrelandMigrationFeatureToggle = exports.getLiveStoreCode = exports.getCountryList = exports.getEnvironment = exports.getStoreCode = void 0;

require("regenerator-runtime/runtime");

var _countries = _interopRequireDefault(require("../countries"));

var _index = _interopRequireWildcard(require("./index"));

var _dayjs = _interopRequireDefault(require("dayjs"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getStoreCode = function getStoreCode() {
  var loc = window.location.host;
  if (loc.includes('0.0.0.0') || loc.includes('localhost') || !window.theme) return 'xd';
  return window.theme.gsCode;
};

exports.getStoreCode = getStoreCode;

var getEnvironment = function getEnvironment(store) {
  var storeCode = store || getStoreCode();
  if (storeCode === 'xd') return 'development';
  if (['xs', 'xs2', 'xs3', 'xs4', 's1', 's2', 's3', 's4'].includes(storeCode)) return 'staging';
  return 'production';
};

exports.getEnvironment = getEnvironment;

var getCountryList = function getCountryList() {
  return _countries["default"].sort(function (x, y) {
    var a = x.name.toLowerCase();
    var b = y.name.toLowerCase(); // eslint-disable-next-line no-nested-ternary

    return a < b ? -1 : a > b ? 1 : 0;
  });
};

exports.getCountryList = getCountryList;

var getLiveStoreCode = function getLiveStoreCode() {
  var storeCode = getStoreCode();

  var stores = _objectSpread(_objectSpread({}, _index["default"]), _index.STAGING_STORES);

  return stores[storeCode].liveStoreCode ? stores[storeCode].liveStoreCode : stores[storeCode].storeCode;
}; // This is only temporary for the Ireland migration hence why it's unelegant


exports.getLiveStoreCode = getLiveStoreCode;

var getIrelandMigrationFeatureToggle = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var IE_REDIRECT_ENDPOINT, storageEnabled, getUnleashedUrl, url, isFeatureToggleEnabled, sessionStorageWrapper, sessionStorage, existing, now, data, isEnabled;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            IE_REDIRECT_ENDPOINT = 'ecom.web.ie.redirect';
            storageEnabled = typeof Storage !== 'undefined';

            getUnleashedUrl = function getUnleashedUrl(stage) {
              return stage && stage.toLowerCase() === 'production' ? 'https://features.api.gymshark.io/api/client/features/' : 'https://features.staging.gymshark.com/api/client/features/';
            };

            url = getUnleashedUrl(getEnvironment(getStoreCode()));

            isFeatureToggleEnabled = function isFeatureToggleEnabled() {
              var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                enabled: false
              };
              return data ? data.enabled : false;
            };

            sessionStorageWrapper = function sessionStorageWrapper() {
              var get = function get(key) {
                try {
                  var json = window.sessionStorage.getItem(key);
                  return JSON.parse(json);
                } catch (error) {
                  // eslint-disable-next-line no-console
                  console.log("Could not retrieve ".concat(key, " from session storage: ").concat(error));
                  return null;
                }
              };

              var set = function set(key, valueToStore) {
                try {
                  var now = (0, _dayjs["default"])();
                  var sessionStorageObject = {
                    value: valueToStore,
                    expiry: now.add(300, 'second')
                  };
                  window.sessionStorage.setItem(key, JSON.stringify(sessionStorageObject));
                } catch (error) {
                  window.sessionStorage.removeItem(key);
                }
              };

              var remove = function remove(key) {
                window.sessionStorage.removeItem(key);
              };

              return {
                get: get,
                set: set,
                remove: remove
              };
            };

            sessionStorage = storageEnabled ? sessionStorageWrapper() : null;

            if (!sessionStorage) {
              _context.next = 14;
              break;
            }

            existing = sessionStorage.get('gs-features_ie_redirect');

            if (!(existing !== null)) {
              _context.next = 14;
              break;
            }

            now = (0, _dayjs["default"])();

            if (!now.isBefore(existing.expiry)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", existing.value);

          case 13:
            sessionStorage.remove('gs-features_ie_redirect');

          case 14:
            _context.next = 16;
            return fetch(url + IE_REDIRECT_ENDPOINT, {
              headers: {
                'UNLEASH-APPNAME': 'ecom.web'
              }
            }).then(function (res) {
              return res.json();
            })["catch"](function (err) {
              return (// eslint-disable-next-line no-console
                console.log("Failed to access feature toggle URI: '".concat(IE_REDIRECT_ENDPOINT, "', defaulting feature to disabled"), err)
              );
            });

          case 16:
            data = _context.sent;
            isEnabled = isFeatureToggleEnabled(data);

            if (sessionStorage) {
              sessionStorage.set('gs-features_ie_redirect', isEnabled);
            }

            return _context.abrupt("return", isEnabled);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getIrelandMigrationFeatureToggle() {
    return _ref.apply(this, arguments);
  };
}();

exports.getIrelandMigrationFeatureToggle = getIrelandMigrationFeatureToggle;